export default {"src":"/_next/static/media/logo.cdc812a8.svg","height":135,"width":202,"blurWidth":0,"blurHeight":0};